// plugins/vant.client.ts
import { defineNuxtPlugin } from '#app'
import { Lazyload } from 'vant'
import 'vant/lib/index.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Lazyload)
})
